import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee66d700")

_pushScopeId("data-v-ee66d700")
const _hoisted_1 = { style: {"text-align":"center","margin-bottom":"8px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/featured-icon.png"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/leaderboard-icon.png"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/profile-icon.png"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/settings-icon.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")

  return (!_ctx.isWeb)
    ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              href: "/featured",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              href: "/leaderboard",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              href: "/profile",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              href: "/settings",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})